import React, { useRef } from 'react';
import SkuStore from '@/stores/sku';
import DrawerStore from '@/stores/drawer';
import localFormat from '@/common/local-format';
import doLog from '@/common/log';
import RoundNumber from '@/common/round-number';

interface PropType {
  type: SkuTypes.TypeInfo;
  price: PriceTypes.Root;
  i18n: DetailTypes.i18n;
  skuAttrs: SkuTypes.SkuAttr[];
}

export default function price(props: PropType) {
  const { type = 'product', price, i18n, skuAttrs } = props;

  const inputRef = useRef(null);
  const skuInfo = SkuStore((state) => state[type]);
  const { selectShow, selectState } = DrawerStore((state) => state);
  const {
    currencyRule: { rate, maximumFractionDigits },
  } = price;

  const getTxt = () => {
    const quantity = Object.values(skuInfo.mapInfo).filter((i) => i.quantity).length;
    if (quantity > 1) {
      if (skuInfo.quantity > 1) {
        return i18n['pc_detail_sku_panel_product_price']
          ?.replace('{0}', `${quantity}`)
          ?.replace('{1}', `${skuInfo.quantity}`);
      }
      return i18n['pc_detail_sku_panel_product_price_front_double_number']
        ?.replace('{0}', `${quantity}`)
        ?.replace('{1}', `${skuInfo.quantity}`);
    }
    if (skuInfo.quantity > 1)
      return i18n['pc_detail_sku_panel_product_price_back_double_number']
        ?.replace('{0}', `${quantity}`)
        ?.replace('{1}', `${skuInfo.quantity}`);
    return i18n['pc_detail_sku_panel_product_price_singular_number']
      ?.replace('{0}', `${quantity}`)
      ?.replace('{1}', `${skuInfo.quantity}`);
  };

  const renderPrice = () => {
    if (skuInfo.quantity > 0) {
      if (skuAttrs) {
        return (
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              doLog('/sc.details.skupanelSelectionDetails', '', 'EXP');
              selectShow(!selectState);
            }}
          >
            {getTxt()}
          </a>
        );
      } else {
        return <span>{getTxt()}</span>;
      }
    }
    return (
      <span>
        {i18n['pc_detail_sku_panel_product_price'].replace('{0}', '0').replace('{1}', '0')}
      </span>
    );
  };

  const getPrice = () => {
    return localFormat(
      RoundNumber(
        type === 'sample' ? skuInfo.totalPrice : skuInfo.totalPrice * rate,
        maximumFractionDigits,
      ),
    );
  };

  return (
    <div className="bottom-item" ref={inputRef}>
      <div className="item-left">{renderPrice()}</div>
      <div className="item-right" data-price-product={getPrice()}>
        {getPrice()}
      </div>
    </div>
  );
}
